import { useState } from "react";
import { money2 } from "../lib/finance";
import { Field, Modal, Select } from "./common";

export function FollowUpModal({ policy, onSave, onClose }) {
  const [form, setForm] = useState({ policyId: policy?.id || "", date: new Date().toISOString().slice(0, 10), status: "Aranacak", nextDate: "", note: "" });
  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  return (
    <Modal title={`${policy?.customer || "Poliçe"} · takip notu`} onClose={onClose}>
      <form onSubmit={(e) => { e.preventDefault(); onSave(form); }}>
        <div className="form-grid">
          <Field label="Arama tarihi" name="date" type="date" value={form.date} onChange={change} required />
          <Field label="Sonraki takip tarihi" name="nextDate" type="date" value={form.nextDate} onChange={change} />
          <Select label="Arama durumu" name="status" value={form.status} onChange={change} options={["Aranacak", "Görüşüldü", "Yenilendi", "İptal", "Cevapsız"]} />
        </div>
        <label className="field full">
          <span>Görüşme sonucu / açıklama</span>
          <textarea data-testid="followup-note-input" name="note" value={form.note} onChange={change} required />
        </label>
        <div className="modal-actions">
          <button type="button" className="outline-button" data-testid="followup-cancel" onClick={onClose}>Vazgeç</button>
          <button className="primary-button" data-testid="followup-save">Takip kaydını sakla</button>
        </div>
      </form>
    </Modal>
  );
}

export function SettingsModal({ settings, onSave, onClose }) {
  const [form, setForm] = useState({ netDivisor: String(settings.netDivisor), personalShare: String(settings.personalShare) });
  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  return (
    <Modal title="Hesaplama ayarları" onClose={onClose}>
      <form onSubmit={(e) => { e.preventDefault(); onSave(form); }}>
        <div className="form-grid">
          <Field label="Net bölen (varsayılan 1.12)" name="netDivisor" type="number" step="0.01" value={form.netDivisor} onChange={change} hint="Net = Brüt ÷ bölen" required />
          <Field label="Kişisel pay (%)" name="personalShare" type="number" step="0.5" value={form.personalShare} onChange={change} hint="Kişisel = Acente komisyonu × pay" required />
        </div>
        <p className="privacy-note">Örnek: Brüt 10.000₺ · Trafik %10 · Net = 8.929₺ · Acente = 893₺ · Kişisel = {money2(893 * (Number(form.personalShare) / 100))}</p>
        <div className="modal-actions">
          <button type="button" className="outline-button" data-testid="settings-cancel" onClick={onClose}>Vazgeç</button>
          <button className="primary-button" data-testid="settings-save">Ayarları kaydet</button>
        </div>
      </form>
    </Modal>
  );
}
